import React, { PropsWithChildren, useMemo } from 'react';

import { createUseContext } from '../../../utils/create-use-context';
import { SentryService } from './sentry-service';
import { useConfigContext } from '../../config/ConfigContext';

const SentryContext = React.createContext<{ sentry: SentryService } | null>(null);
SentryContext.displayName = 'SentryContext';

export function SentryContextProvider({ children }: PropsWithChildren) {
  const config = useConfigContext();
  const contextValue = useMemo(() => {
    return {
      sentry: new SentryService(config.sentryDsn, config.environment)
    }
  }, []);

  return (
    <SentryContext.Provider value={contextValue}>
      { children }
    </SentryContext.Provider>
  )
}

export const useSentryContext = createUseContext(SentryContext);
